import React from "react";
import styles from "./AnalysisPanel.module.css";

import type { TokenUsageProps } from "../../api";

interface TokenUsageGraphProps {
    tokenUsage: TokenUsageProps;
    reasoningEffort?: string;
}

export const TokenUsageGraph: React.FC<TokenUsageGraphProps> = ({ tokenUsage, reasoningEffort }) => {
    const { prompt_tokens, completion_tokens, total_tokens } = tokenUsage;
    const reasoning_tokens = tokenUsage.reasoning_tokens ?? 0;
    const cached_input_tokens = tokenUsage.cached_input_tokens ?? 0;

    // Calculate percentage widths relative to total_tokens
    const calcPercent = (value: number) => (total_tokens ? (value / total_tokens) * 100 : 0) + "%";

    return (
        <div className={styles.tokenUsageGraph}>
            <div className={styles.header}>Token Usage</div>
            <div className={styles.primaryBarContainer} style={{ width: "100%" }}>
                <div className={`${styles.tokenBar} ${styles.promptBar}`} style={{ width: calcPercent(prompt_tokens) }}>
                    {cached_input_tokens > 0 && (
                        <div className={styles.cachedFill} style={{ width: (prompt_tokens ? (cached_input_tokens / prompt_tokens) * 100 : 0) + "%" }} />
                    )}
                    <span className={styles.tokenLabel}>
                        Prompt: {prompt_tokens}
                        {cached_input_tokens > 0 && ` (${cached_input_tokens} cached)`}
                    </span>
                </div>
                {reasoningEffort != null && reasoningEffort !== "" && (
                    <div className={`${styles.tokenBar} ${styles.reasoningBar}`} style={{ width: calcPercent(reasoning_tokens) }}>
                        <span className={styles.tokenLabel}>Reasoning: {reasoning_tokens}</span>
                    </div>
                )}
                <div className={`${styles.tokenBar} ${styles.outputBar}`} style={{ width: calcPercent(completion_tokens - reasoning_tokens) }}>
                    <span className={styles.tokenLabel}>Output: {completion_tokens - reasoning_tokens}</span>
                </div>
            </div>

            <div className={`${styles.tokenBar} ${styles.totalBar}`} style={{ width: calcPercent(total_tokens) }}>
                <span className={styles.tokenLabel}>Total: {total_tokens}</span>
            </div>
        </div>
    );
};
